import { render, staticRenderFns } from "./ziliaoguidang.vue?vue&type=template&id=d25cad32&scoped=true&"
import script from "./ziliaoguidang.vue?vue&type=script&lang=js&"
export * from "./ziliaoguidang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25cad32",
  null
  
)

export default component.exports